import { createStateSelectorHook } from 'src/lib/sweetState';

import { SavedDocumentViewStore } from './store';

const useSavedDocumentViewState = createStateSelectorHook(SavedDocumentViewStore, [
  'threads',
  'textRatings',
  'draft',
  'openPanel',
  'creatingThread',
  'replyingThreadId',
]);

export const useViewState = () => {
  const savedDocumentViewState = useSavedDocumentViewState();
  return { ...savedDocumentViewState };
};
